<script>
import { mapActions, mapGetters } from 'vuex'
import { VoucherStatus } from '@/enums/VoucherStatus.js'
import { voucherStatusMixin } from '@/mixins/voucherStatusMixin'
import BaseDataForm from '@/components/profile/billingData/BaseDataForm.vue'
export default {
  name: 'VoucherComponent',
  components: { BaseDataForm },
  mixins: [voucherStatusMixin],
  data: () => ({
    voucherStatus: VoucherStatus,
    dialog: {
      state: false,
      voucherStatus: null
    },
    voucherName: null,
    voucherSource: null
  }),
  computed: {
    ...mapGetters(['isAuthenticated', 'locale', 'voucher']),
    userHasNoAplId() {
      if (this.dialog.voucherStatus)
        return this.dialog.voucherStatus.code === VoucherStatus.UserHasNoAplId
      else return false
    }
  },
  created: async function () {
    if (this.$route.name === 'voucher') {
      // only in 'voucher'-route get code from query
      this.voucherName = this.$route.query.code
      this.voucherSource = 'query'
    } else {
      // otherwise get code from store
      this.voucherName = this.voucher
      this.voucherSource = 'store'
    }
    // define default state / status
    this.dialog.voucherStatus = this.voucherStatusConfig[VoucherStatus.Loading]
    // voucher in route or in store ?
    if (this.voucherName) {
      // display dialog
      this.dialog.state = true
      // try to active voucher
      this.activateVoucher()
    }
  },
  methods: {
    ...mapActions(['setVoucher', 'resetVoucher', 'getCreditBalance']),
    redirect(location) {
      if (this.voucherSource === 'store') this.dialog.state = false
      else
        this.$router.push({ name: location, params: { locale: this.locale } })
    },
    async activateVoucher() {
      this.dialog.voucherStatus =
        this.voucherStatusConfig[VoucherStatus.Loading]
      await this.$userService
        .activateVoucher({ voucherCode: this.voucherName })
        .then(async response => {
          this.dialog.voucherStatus = this.voucherStatusConfig[response]
          this.resetVoucher()
          await this.getCreditBalance()
        })
        .catch(e => {
          switch (e.response.status) {
            case 401:
              this.dialog.voucherStatus =
                this.voucherStatusConfig[VoucherStatus.Unauthorized]
              // save voucher in store
              this.setVoucher(this.voucherName)
              break

            default:
              this.dialog.voucherStatus =
                this.voucherStatusConfig[VoucherStatus.Error]
              break
          }
        })
    }
  }
}
</script>
<template>
  <v-dialog
    v-model="dialog.state"
    :max-width="userHasNoAplId ? 1024 : 500"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <DialogBaseColoredTitle :color="dialog.voucherStatus.color">{{
          $t('component.credit.voucher.title')
        }}</DialogBaseColoredTitle>
      <v-divider></v-divider>
      <DialogBaseText class="text-center">
        <v-row class="justify-center text-center">
          <v-col>
            <v-icon
              :color="dialog.voucherStatus.color"
              size="74"
              class="icon_border_round"
            >mdi-gift</v-icon>
            &nbsp;
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2>{{ $t('component.credit.voucher.code') }} {{ voucherName }}</h2>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col>
            <h3 v-html="dialog.voucherStatus.text"></h3>
          </v-col>
        </v-row>
      </DialogBaseText>
      <v-divider></v-divider>
      <DialogBaseText v-if="userHasNoAplId">
        <BaseDataForm
          :hide-info-text="true"
          :shrink="true"
          @submitted="activateVoucher" />
      </DialogBaseText>
      <v-divider v-if="userHasNoAplId"></v-divider>
      <DialogBaseActions
        v-if="dialog.voucherStatus.code === voucherStatus.Unauthorized">
        <v-row justify="space-between" class="pa-0 ma-0">
          <v-col cols="12" sm="auto" class="pa-sm-0 ma-0">
            <v-btn
              class="text-center px-8"
              color="error"
              @click.stop="redirect('register')">
              {{ $t('button.register') }}</v-btn>
          </v-col>
          <v-col cols="12" sm="auto" class="pa-sm-0 ma-0">
            <v-btn
              class="text-center px-8"
              color="primary"
              @click.stop="redirect('login')">
              {{ $t('button.login') }}</v-btn>
          </v-col>
        </v-row>
      </DialogBaseActions>
      <DialogBaseActions
        v-else-if="
          ![voucherStatus.Loading, voucherStatus.UserHasNoAplId].includes(
            dialog.voucherStatus.code )">
        <v-btn
          class="text-center px-8"
          :color="dialog.voucherStatus.color"
          @click.stop="redirect('dashboard')">
          {{ $t('button.ok') }}</v-btn>
      </DialogBaseActions>
    </v-card>
  </v-dialog>
</template>
<style lang="scss">
.icon_border_round {
  border-radius: 50px;
  border: 2px solid;
  padding: 10px;
  width: 100px;
  height: 100px;
}
</style>
